import { buildFormatLongFn } from "../../_lib/buildFormatLongFn.js";
var dateFormats = {
  full: "EEEE d MMMM y",
  "long": "d MMMM y",
  medium: "d MMM y",
  "short": "dd-MM-y"
};
var timeFormats = {
  full: "HH:mm:ss zzzz",
  "long": "HH:mm:ss z",
  medium: "HH:mm:ss",
  "short": "HH:mm"
};
var dateTimeFormats = {
  full: "{{date}} 'om' {{time}}",
  "long": "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  "short": "{{date}}, {{time}}"
};
export var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};